import { CreateCheckout } from '~core/payments';
import { onErrorShowMessage } from '~src/errors';

/**
 * Creates a checkout session
 * @param {string} selectedModuleId - Selected module ID
 * @param {Object} user - User info
 * @returns {Promise<Object|null>} Checkout session or null if creation fails
 */
const createCheckoutSession = async (selectedModuleId, user) => {
  try {
    const createCheckout = new CreateCheckout(process.env.USER_API_URL);
    const createCheckoutSessionApiUrl = createCheckout
      .withoutRedirect()
      .withRedirectOnCompletion('never')
      .withUIMode('embedded')
      .withModuleId(selectedModuleId)
      .withOrgId(user.org_pointer.objectId)
      .getUrl();

    // Make a GET request to the checkout session API URL
    const response = await fetch(createCheckoutSessionApiUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching checkout session:', error);
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text:
        'Si è verificato un errore durante la creazione della sessione di pagamento.',
      confirmButtonColor: '#278e8e',
    });
    return null;
  }
};

export default createCheckoutSession;
